import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice, isNil } from '@grandvisionhq/utils';
import { useCart } from '../../../context/Cart/context.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/events';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { Mixed } from '../layout/Mixed.js';
import { Regular } from '../layout/Regular.js';
import { Subscription } from '../layout/Subscription.js';
import { containsOnlyContactLensesSubscriptionLineItems } from '../utils/contains-only-contact-lenses-subscription-line-items.js';

const TotalsContainer = ({ shouldShowSubTotal , shouldHideSubscriptionExplainer , shouldShowTotalDiscount , className , isMiniCart  })=>{
    const settings = useCartSettings();
    const { cart  } = useCart();
    const { locale , currency , getLabel , getFormattedLabel  } = useIntl();
    const discountedPrice = (cart === null || cart === void 0 ? void 0 : cart.prices.discountPrice) ? cart.prices.subTotalPrice - cart.prices.discountPrice : (cart === null || cart === void 0 ? void 0 : cart.prices.subTotalPrice) || 0;
    const freeShippingRemainder = (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.freeAbove) ? cart.shippingMethod.freeAbove - discountedPrice : undefined;
    const formattedPrice = formatPrice({
        locale,
        value: freeShippingRemainder,
        currency,
        isCentAmount: true
    });
    const labels = React.useMemo(()=>({
            delivery: getLabel('cart.delivery'),
            freeDelivery: getLabel('cart.delivery.forFree'),
            subTotal: getLabel('cart.value.subTotal'),
            total: getLabel('cart.value.total'),
            todaysTotal: getLabel('cart.value.todaysTotal'),
            totalDiscount: getLabel('cart.value.totalDiscount'),
            paymentMethodPrice: getLabel('cart.value.paymentMethod'),
            subscriptionHeader: getLabel('cart.subscription.header'),
            freeShippingRemainder: getFormattedLabel('cart.delivery.freeShippingRemainder', {
                parseHTML: true,
                labelData: {
                    price: `<span className="price">${formattedPrice}</span>`
                }
            }),
            freeShippingReached: getLabel('cart.delivery.freeShippingReached'),
            totalItems: getLabel('cart.value.totalItems'),
            productDiscounts: getLabel('cart.value.productDiscounts')
        })
    , [
        getLabel,
        getFormattedLabel,
        formattedPrice
    ]);
    if (!cart) {
        return null;
    }
    const cartSettings = swcHelpers.objectSpread({}, settings, {
        shouldShowSubTotal: !isNil(shouldShowSubTotal) ? shouldShowSubTotal : settings.shouldShowSubTotal,
        shouldShowTotalDiscount: !isNil(shouldShowTotalDiscount) ? shouldShowTotalDiscount : settings.shouldShowTotalDiscount
    });
    if (cart.subscription && containsOnlyContactLensesSubscriptionLineItems(cart.lineItems)) {
        return /*#__PURE__*/ React.createElement(Subscription, {
            className: className,
            voucherCodes: cart.voucherCodes,
            subscription: cart.subscription,
            lineItems: cart.lineItems,
            shouldHideSubscriptionExplainer: shouldHideSubscriptionExplainer
        });
    }
    if (cart.subscription) {
        return /*#__PURE__*/ React.createElement(Mixed, {
            className: className,
            currency: currency,
            labels: labels,
            lineItems: cart.lineItems,
            prices: cart.prices,
            settings: cartSettings,
            shouldHideSubscriptionExplainer: shouldHideSubscriptionExplainer,
            subscription: cart.subscription,
            voucherCodes: cart.voucherCodes
        });
    }
    return /*#__PURE__*/ React.createElement(Regular, {
        className: className,
        currency: currency,
        labels: labels,
        prices: cart.prices,
        settings: cartSettings,
        voucherCodes: cart.voucherCodes,
        freeShippingThreshold: cart.shippingMethod.freeAbove,
        discountedPrice: discountedPrice,
        isMiniCart: isMiniCart,
        numberOfItems: cart.numberOfItems
    });
};

export { TotalsContainer };
//# sourceMappingURL=TotalsContainer.js.map
